<template>
  <v-row>

    <v-col cols="12" class="mt-4">
      <v-sheet
        outlined
        height="180px"
        cols="12" class="d-flex align-center justify-center">
        <v-col>
          <h1 
            class="text-center"
            style="font-size: 72px;font-weight: 300;">
            {{ interaction_count }}
          </h1>

          <h4 class="text-center">Interacciones totales</h4>
        </v-col>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por vistas:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="bar" 
              height="600" 
              :options="interaction_views_chart_options" 
              :series="interaction_views_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones totales por día:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="400" 
              :options="interaction_per_day_chart_options" 
              :series="interaction_per_day_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por día:</h4>
          </v-col>
  
          <v-col cols="12" class="pl-8 pr-8">  
            <v-select
              v-model="selectedDate"
              :items="days"
              item-text="text"
              item-value="date"
              label="Selecciona una fecha"
              outlined
            ></v-select>
          </v-col>
        </v-row>

      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        height="180px"
        cols="12" class="d-flex align-center justify-center">
        <v-col>
          <h1 
            class="text-center"
            style="font-size: 72px;font-weight: 300;">
            {{ interaction_count_day }}
          </h1>

          <h4 v-if="!loading_per_day" class="text-center">Interacciones del {{ transformarFecha(selectedDate) }}</h4>
        </v-col>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        min-height="600">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4 v-if="!loading_per_day">Interacciones por vistas {{ transformarFecha(selectedDate) }}</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              v-if="!loading_per_day"
              type="bar" 
              height="600" 
              :options="interaction_views_day_chart_options" 
              :series="interaction_views_day_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col 
      cols="12"
      xl="6"
      md="6"
      xs="12">
      <v-sheet
        outlined
        v-if="!loading_per_day">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por hora en la Home:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="280" 
              :options="interaction_home_hour_chart_options" 
              :series="interaction_home_hour_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col 
      cols="12"
      xl="6"
      md="6"
      xs="12">
      <v-sheet
        outlined
        v-if="!loading_per_day">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por hora en los Auditorios:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="280" 
              :options="interaction_auditoriums_hour_chart_options" 
              :series="interaction_auditoriums_hour_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col 
      cols="12"
      xl="6"
      md="6"
      xs="12">
      <v-sheet
        outlined
        v-if="!loading_per_day">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por hora en el Programa:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="280" 
              :options="interaction_program_hour_chart_options" 
              :series="interaction_program_hour_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col 
      cols="12"
      xl="6"
      md="6"
      xs="12">
      <v-sheet
        outlined
        v-if="!loading_per_day">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por hora en la Galeria de Proyectos:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="280" 
              :options="interaction_project_gallery_hour_chart_options" 
              :series="interaction_project_gallery_hour_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col 
      cols="12"
      xl="6"
      md="6"
      xs="12">
      <v-sheet
        outlined
        v-if="!loading_per_day">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por hora con los Stands:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="280" 
              :options="interaction_views_stand_hour_chart_options" 
              :series="interaction_views_stand_hour_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col 
      cols="12"
      xl="6"
      md="6"
      xs="12">
      <v-sheet
        outlined
        v-if="!loading_per_day">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por hora con los Likes:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="280" 
              :options="interaction_likes_hour_chart_options" 
              :series="interaction_likes_hour_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col 
      cols="12"
      xl="6"
      md="6"
      xs="12">
      <v-sheet
        outlined
        v-if="!loading_per_day">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por hora con Jurados y Evaluadores:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="280" 
              :options="interaction_juries_evaluators_hour_chart_options" 
              :series="interaction_juries_evaluators_hour_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col 
      cols="12"
      xl="6"
      md="6"
      xs="12">
      <v-sheet
        outlined
        v-if="!loading_per_day">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por hora con los Speakers:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="280" 
              :options="interaction_speakers_hour_chart_options" 
              :series="interaction_speakers_hour_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col 
      cols="12"
      xl="6"
      md="6"
      xs="12">
      <v-sheet
        outlined
        v-if="!loading_per_day">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por hora con los Asistentes:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="280" 
              :options="interaction_assistants_hour_chart_options" 
              :series="interaction_assistants_hour_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col 
      cols="12"
      xl="6"
      md="6"
      xs="12">
      <v-sheet
        outlined
        v-if="!loading_per_day">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por hora con los Emprendedores:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="280" 
              :options="interaction_entrepreneurs_hour_chart_options" 
              :series="interaction_entrepreneurs_hour_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col 
      cols="12"
      xl="6"
      md="6"
      xs="12">
      <v-sheet
        outlined
        v-if="!loading_per_day">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por hora con los Sponsors:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="280" 
              :options="interaction_sponsors_hour_chart_options" 
              :series="interaction_sponsors_hour_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col 
      cols="12"
      xl="6"
      md="6"
      xs="12">
      <v-sheet
        outlined
        v-if="!loading_per_day">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Interacciones por hora con Acerca de JIJE:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="area" 
              height="280" 
              :options="interaction_about_hour_chart_options" 
              :series="interaction_about_hour_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
    
    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading_per_day"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'interactionsIndicator',

    props:['edition_id'],
    data: () => ({
      loading:true,
      loading_per_day:false,
      show:false,

      interaction_count: 0,
      interaction_home_count: 0,
      interaction_auditoriums_count: 0,
      interaction_program_count: 0,
      interaction_project_gallery_count: 0,
      interaction_stands_count: 0,
      interaction_like_count: 0,
      interaction_view_count: 0,
      interaction_juries_evaluators_count: 0,
      interaction_speakers_count: 0,
      interaction_assistants_count: 0,
      interaction_entrepreneurs_count: 0,
      interaction_sponsors_count: 0,
      interaction_about_count: 0,

      interaction_views_chart_options: {
        name: 'Vistas',
        plotOptions: {
          bar: {
            borderRadius: 6,
            horizontal: true,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: [ 'Landing page',
                        'Home', 
                        'Auditorios', 
                        'Programa', 
                        'Galeria de Proyectos', 
                        'Likes de Stands', 
                        'Vistas de Stands', 
                        'Jurado y Evaluadores', 
                        'Speakers', 
                        'Asistentes', 
                        'Emprendedores',
                        'Sponsors',
                        'Acerca de JIJE'
                      ]
        }
      },
      interaction_views_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      interaction_count_day: 0,
      interaction_landing_page_count_day: 0,
      interaction_home_count_day: 0,
      interaction_auditoriums_count_day: 0,
      interaction_program_count_day: 0,
      interaction_project_gallery_count_day: 0,
      interaction_stands_count_day: 0,
      interaction_like_count_day: 0,
      interaction_view_count_day: 0,
      interaction_juries_evaluators_count_day: 0,
      interaction_speakers_count_day: 0,
      interaction_assistants_count_day: 0,
      interaction_entrepreneurs_count_day: 0,
      interaction_sponsors_count_day: 0,
      interaction_about_count_day: 0,

      interaction_views_day_chart_options: {
        name: 'Vistas por día',
        plotOptions: {
          bar: {
            borderRadius: 6,
            horizontal: true,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: [ 'Landing Page',
                        'Home', 
                        'Auditorios', 
                        'Programa', 
                        'Galeria de Proyectos', 
                        'Likes de Stands', 
                        'Vistas de Stands', 
                        'Jurado y Evaluadores', 
                        'Speakers', 
                        'Asistentes', 
                        'Emprendedores',
                        'Sponsors',
                        'Acerca de JIJE'
                      ]
        }
      },
      interaction_views_day_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      visits_per_day: [],
      interaction_per_day_chart_options: {
        name: 'Vistas por día',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_per_day_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      selectedDate:null,
      days:[],

      interaction_home_per_hour: [],
      interaction_home_hour_chart_options: {
        name: 'Vistas por hora',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_home_hour_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      interaction_auditoriums_per_hour: [],
      interaction_auditoriums_hour_chart_options: {
        name: 'Vistas por hora',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_auditoriums_hour_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      interaction_program_per_hour: [],
      interaction_program_hour_chart_options: {
        name: 'Vistas por hora',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_program_hour_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      interaction_project_gallery_per_hour: [],
      interaction_project_gallery_hour_chart_options: {
        name: 'Vistas por hora',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_project_gallery_hour_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      interaction_views_stand_per_hour: [],
      interaction_views_stand_hour_chart_options: {
        name: 'Vistas por hora',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_views_stand_hour_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],
      
      interaction_likes_per_hour: [],
      interaction_likes_hour_chart_options: {
        name: 'Vistas por hora',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_likes_hour_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      interaction_juries_evaluators_per_hour: [],
      interaction_juries_evaluators_hour_chart_options: {
        name: 'Vistas por hora',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_juries_evaluators_hour_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      interaction_speakers_per_hour: [],
      interaction_speakers_hour_chart_options: {
        name: 'Vistas por hora',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_speakers_hour_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      interaction_assistants_per_hour: [],
      interaction_assistants_hour_chart_options: {
        name: 'Vistas por hora',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_assistants_hour_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      interaction_entrepreneurs_per_hour: [],
      interaction_entrepreneurs_hour_chart_options: {
        name: 'Vistas por hora',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_entrepreneurs_hour_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      interaction_sponsors_per_hour: [],
      interaction_sponsors_hour_chart_options: {
        name: 'Vistas por hora',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_sponsors_hour_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],

      interaction_about_per_hour: [],
      interaction_about_hour_chart_options: {
        name: 'Vistas por hora',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      interaction_about_hour_series: [
        {
          name: 'Visitas',
          data: []
        }
      ],
      
    }),
    watch: {
      selectedDate: {
        handler: function() {
            Promise.all([
              this.loading_per_day  =true,
              this.getInteractionsDays(),
              this.getInteractionsHomeDayHour(),
              this.getInteractionsAuditoriumsDayHour(),
              this.getInteractionsProgramDayHour(),
              this.getInteractionsProjectGalleryDayHour(),
              this.getInteractionsViewsStanDayHour(),
              this.getInteractionsLikesDayHour(),
              this.getInteractionsJuriesEvaluatorsDayHour(),
              this.getInteractionsSpeakersDayHour(),
              this.getInteractionsAssistantsDayHour(),
              this.getInteractionsEntrepreneursDayHour(),
              this.getInteractionsSponsorsDayHour(),
              this.getInteractionsAboutJIJEDayHour()
            ]).then(() => {
              this.loading_per_day = false
            }).catch((error) => {
              console.log(error)
            });
        }
      }
    },
    methods:{
      async getInteractions(){
        await axios.get('admin/indicators/interactions/'+this.edition_id).then(response =>{
          this.interaction_count = response.data.data.interaction_count
          this.interaction_landing_page = response.data.data.interaction_landing_page
          this.interaction_home_count = response.data.data.interaction_home_count  
          this.interaction_auditoriums_count = response.data.data.interaction_auditoriums_count 
          this.interaction_program_count = response.data.data.interaction_program_count 
          this.interaction_project_gallery_count = response.data.data.interaction_project_gallery_count 
          this.interaction_like_count = response.data.data.interaction_like_count
          this.interaction_view_count = response.data.data.interaction_view_count
          this.interaction_juries_evaluators_count = response.data.data.interaction_juries_evaluators_count 
          this.interaction_speakers_count = response.data.data.interaction_speakers_count  
          this.interaction_assistants_count = response.data.data.interaction_assistants_count  
          this.interaction_entrepreneurs_count = response.data.data.interaction_entrepreneurs_count 
          this.interaction_sponsors_count = response.data.data.interaction_sponsors_count  
          this.interaction_about_count = response.data.data.interaction_about_count 
          
          this.show=true
        }).catch(error => {
          console.log(error);
        })
      },

      setData(){
        this.interaction_views_series[0].data.push(this.interaction_landing_page)
        this.interaction_views_series[0].data.push(this.interaction_home_count)
        this.interaction_views_series[0].data.push(this.interaction_auditoriums_count)
        this.interaction_views_series[0].data.push(this.interaction_program_count)
        this.interaction_views_series[0].data.push(this.interaction_project_gallery_count)
        this.interaction_views_series[0].data.push(this.interaction_like_count)
        this.interaction_views_series[0].data.push(this.interaction_view_count)
        this.interaction_views_series[0].data.push(this.interaction_juries_evaluators_count)
        this.interaction_views_series[0].data.push(this.interaction_speakers_count)
        this.interaction_views_series[0].data.push(this.interaction_assistants_count)
        this.interaction_views_series[0].data.push(this.interaction_entrepreneurs_count)
        this.interaction_views_series[0].data.push(this.interaction_sponsors_count)
        this.interaction_views_series[0].data.push(this.interaction_about_count)
      },

      async getInteractionsPerDay(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/pages-visist-per-day').then(response =>{
          this.visits_per_day = response.data.data.visits_per_day

          this.visits_per_day.forEach( e =>{
            const fecha_aux = { date: e.date, text: this.transformarFecha(e.date) }
            this.days.push(fecha_aux);
            if(!this.selectedDate){
              this.selectedDate = e.date
            }
            this.interaction_per_day_chart_options.xaxis.categories.push(this.transformarFecha(e.date))
            this.interaction_per_day_series[0].data.push(e.count)
          })

        }).catch(error => {
          console.log(error);
        })
      },

      transformarFecha(fecha) {
        if(fecha){
          const [año, mes, dia] = fecha.split('-');
          return `${dia}/${mes}/${año}`;
        }
        return '00/00/0000'
      },

      async getInteractionsDays(){
        this.interaction_views_day_series[0].data = []
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate).then(response =>{
          this.interaction_count_day = response.data.data.interaction_count_day
          this.interaction_landing_page_count_day = response.data.data.interaction_landing_page_count_day
          this.interaction_home_count_day = response.data.data.interaction_home_count_day  
          this.interaction_auditoriums_count_day = response.data.data.interaction_auditoriums_count_day 
          this.interaction_program_count_day = response.data.data.interaction_program_count_day 
          this.interaction_project_gallery_count_day = response.data.data.interaction_project_gallery_count_day 
          this.interaction_like_count_day = response.data.data.interaction_like_count_day
          this.interaction_view_count_day = response.data.data.interaction_view_count_day
          this.interaction_juries_evaluators_count_day = response.data.data.interaction_juries_evaluators_count_day
          this.interaction_speakers_count_day = response.data.data.interaction_speakers_count_day  
          this.interaction_assistants_count_day = response.data.data.interaction_assistants_count_day  
          this.interaction_entrepreneurs_count_day = response.data.data.interaction_entrepreneurs_count_day 
          this.interaction_sponsors_count_day = response.data.data.interaction_sponsors_count_day  
          this.interaction_about_count_day = response.data.data.interaction_about_count_day 
          this.setDataDay()
          
        }).catch(error => {
          console.log(error);
        })
      },

      setDataDay(){
        this.interaction_views_day_series[0].data.push(this.interaction_landing_page_count_day)
        this.interaction_views_day_series[0].data.push(this.interaction_home_count_day)
        this.interaction_views_day_series[0].data.push(this.interaction_auditoriums_count_day)
        this.interaction_views_day_series[0].data.push(this.interaction_program_count_day)
        this.interaction_views_day_series[0].data.push(this.interaction_project_gallery_count_day)
        this.interaction_views_day_series[0].data.push(this.interaction_like_count_day)
        this.interaction_views_day_series[0].data.push(this.interaction_view_count_day)
        this.interaction_views_day_series[0].data.push(this.interaction_juries_evaluators_count_day)
        this.interaction_views_day_series[0].data.push(this.interaction_speakers_count_day)
        this.interaction_views_day_series[0].data.push(this.interaction_assistants_count_day)
        this.interaction_views_day_series[0].data.push(this.interaction_entrepreneurs_count_day)
        this.interaction_views_day_series[0].data.push(this.interaction_sponsors_count_day)
        this.interaction_views_day_series[0].data.push(this.interaction_about_count_day)
      },

      async getInteractionsHomeDayHour(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate+'/home-per-days').then(response =>{
          this.interaction_home_per_hour = response.data.data.interaction_home_per_hour

          this.interaction_home_hour_chart_options.xaxis.categories = []
          this.interaction_home_hour_series[0].data = []

          this.interaction_home_per_hour.forEach( e =>{
            this.interaction_home_hour_chart_options.xaxis.categories.push(e.hour)
            this.interaction_home_hour_series[0].data.push(e.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getInteractionsAuditoriumsDayHour(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate+'/auditoriums-per-days').then(response =>{
          this.interaction_auditoriums_per_hour = response.data.data.interaction_auditoriums_per_hour

          this.interaction_auditoriums_hour_chart_options.xaxis.categories = []
          this.interaction_auditoriums_hour_series[0].data = []

          this.interaction_auditoriums_per_hour.forEach( e =>{
            this.interaction_auditoriums_hour_chart_options.xaxis.categories.push(e.hour)
            this.interaction_auditoriums_hour_series[0].data.push(e.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getInteractionsProgramDayHour(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate+'/program-per-days').then(response =>{
          this.interaction_program_per_hour = response.data.data.interaction_program_per_hour

          this.interaction_program_hour_chart_options.xaxis.categories = []
          this.interaction_program_hour_series[0].data = []

          this.interaction_program_per_hour.forEach( e =>{
            this.interaction_program_hour_chart_options.xaxis.categories.push(e.hour)
            this.interaction_program_hour_series[0].data.push(e.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getInteractionsProjectGalleryDayHour(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate+'/project-gallery-per-days').then(response =>{
          this.interaction_project_gallery_per_hour = response.data.data.interaction_project_gallery_per_hour

          this.interaction_project_gallery_hour_chart_options.xaxis.categories = []
          this.interaction_project_gallery_hour_series[0].data = []

          this.interaction_project_gallery_per_hour.forEach( e =>{
            this.interaction_project_gallery_hour_chart_options.xaxis.categories.push(e.hour)
            this.interaction_project_gallery_hour_series[0].data.push(e.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getInteractionsViewsStanDayHour(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate+'/views-stand-per-days').then(response =>{
          this.interaction_views_stand_per_hour = response.data.data.interaction_views_stand_per_hour

          this.interaction_views_stand_hour_chart_options.xaxis.categories = []
          this.interaction_views_stand_hour_series[0].data = []

          this.interaction_views_stand_per_hour.forEach( e =>{
            this.interaction_views_stand_hour_chart_options.xaxis.categories.push(e.hour)
            this.interaction_views_stand_hour_series[0].data.push(e.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getInteractionsLikesDayHour(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate+'/likes-per-days').then(response =>{
          this.interaction_likes_per_hour = response.data.data.interaction_likes_per_hour

          this.interaction_likes_hour_chart_options.xaxis.categories = []
          this.interaction_likes_hour_series[0].data = []

          this.interaction_likes_per_hour.forEach( e =>{
            this.interaction_likes_hour_chart_options.xaxis.categories.push(e.hour)
            this.interaction_likes_hour_series[0].data.push(e.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getInteractionsJuriesEvaluatorsDayHour(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate+'/juries-evaluators-per-days').then(response =>{
          this.interaction_juries_evaluators_per_hour = response.data.data.interaction_juries_evaluators_per_hour

          this.interaction_juries_evaluators_hour_chart_options.xaxis.categories = []
          this.interaction_juries_evaluators_hour_series[0].data = []

          this.interaction_juries_evaluators_per_hour.forEach( e =>{
            this.interaction_juries_evaluators_hour_chart_options.xaxis.categories.push(e.hour)
            this.interaction_juries_evaluators_hour_series[0].data.push(e.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },
      
      async getInteractionsSpeakersDayHour(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate+'/speakers-per-days').then(response =>{
          this.interaction_speakers_per_hour = response.data.data.interaction_speakers_per_hour

          this.interaction_speakers_hour_chart_options.xaxis.categories = []
          this.interaction_speakers_hour_series[0].data = []

          this.interaction_speakers_per_hour.forEach( e =>{
            this.interaction_speakers_hour_chart_options.xaxis.categories.push(e.hour)
            this.interaction_speakers_hour_series[0].data.push(e.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getInteractionsAssistantsDayHour(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate+'/assistants-per-days').then(response =>{
          this.interaction_assistants_per_hour = response.data.data.interaction_assistants_per_hour

          this.interaction_assistants_hour_chart_options.xaxis.categories = []
          this.interaction_assistants_hour_series[0].data = []

          this.interaction_assistants_per_hour.forEach( e =>{
            this.interaction_assistants_hour_chart_options.xaxis.categories.push(e.hour)
            this.interaction_assistants_hour_series[0].data.push(e.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getInteractionsEntrepreneursDayHour(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate+'/entrepreneurs-per-days').then(response =>{
          this.interaction_entrepreneurs_per_hour = response.data.data.interaction_entrepreneurs_per_hour

          this.interaction_entrepreneurs_hour_chart_options.xaxis.categories = []
          this.interaction_entrepreneurs_hour_series[0].data = []

          this.interaction_entrepreneurs_per_hour.forEach( e =>{
            this.interaction_entrepreneurs_hour_chart_options.xaxis.categories.push(e.hour)
            this.interaction_entrepreneurs_hour_series[0].data.push(e.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getInteractionsSponsorsDayHour(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate+'/sponsors-per-days').then(response =>{
          this.interaction_sponsors_per_hour = response.data.data.interaction_sponsors_per_hour

          this.interaction_sponsors_hour_chart_options.xaxis.categories = []
          this.interaction_sponsors_hour_series[0].data = []

          this.interaction_sponsors_per_hour.forEach( e =>{
            this.interaction_sponsors_hour_chart_options.xaxis.categories.push(e.hour)
            this.interaction_sponsors_hour_series[0].data.push(e.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getInteractionsAboutJIJEDayHour(){
        await axios.get('admin/indicators/interactions/'+this.edition_id+'/day/'+this.selectedDate+'/about-per-days').then(response =>{
          this.interaction_about_per_hour = response.data.data.interaction_about_per_hour

          this.interaction_about_hour_chart_options.xaxis.categories = []
          this.interaction_about_hour_series[0].data = []

          this.interaction_about_per_hour.forEach( e =>{
            this.interaction_about_hour_chart_options.xaxis.categories.push(e.hour)
            this.interaction_about_hour_series[0].data.push(e.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },
      
    },
    created(){
      Promise.all([
        this.getInteractions(),
        this.getInteractionsPerDay()
      ]).then(() => {
        this.setData()
        this.loading = false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>